import { Component, OnInit } from '@angular/core';
import { ReceiptItemService } from '../receipt-item.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ReceiptService } from '../receipt.service';

@Component({
  selector: 'app-receipt-list-items',
  templateUrl: './receipt-list-items.component.html',
  styleUrls: ['./receipt-list-items.component.css'],
  providers: [ReceiptItemService,ReceiptService]
})
export class ReceiptListItemsComponent implements OnInit {

  receiptCartItemServer: any[]= [];
  loadingCartItemServer:boolean = true;
  receipt:{};
  visibleReject: boolean = false;
  invoiceNumber:string;
  id:string;
  title:string = "Поступившие товары";



  constructor(
    private receiptItemService: ReceiptItemService,
    private receiptService: ReceiptService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _location: Location) {

    activatedRoute.params.subscribe(params=>{this.id=params['id']});
    
    this.onLoad();
   }

  ngOnInit() {
    this.receipt = {status: ""};
  }

  onLoad(){

    this.receiptService.getReceiptById(this.id).subscribe(response=>{
      
      this.receipt = response['data'];
      this.invoiceNumber = this.receipt['invoice_number'];
      if(this.receipt['status']['id']==5){
        this.visibleReject = false;
      }else{
        this.visibleReject = true;
      }
    });



    this.loadDataTable();
  }

  loadDataTable(){
    this.receiptCartItemServer=[];
    this.loadingCartItemServer = true;
    this.receiptItemService.getReceiptItemById(this.id).subscribe(response=>{ 
      this.receiptCartItemServer = response['data'] ; 
      this.loadingCartItemServer = false;
    })
  }

  print() {
    this.receiptService.printReceipt(this.id).subscribe(response => { window.open(response['data'].link); });
  }

  backClicked() {
    this._location.back();
}

reject(){
  this.router.navigate(['/dashboard/receipt-update/',this.id]);
}

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/reseipts/receipt-list-items/receipt-list-items.component.ts